import { Chip, ChipProps } from "@mui/material";
import React from "react";

import { FileAccessibility } from "../../../../Core/Api/Types/file-accessibility";
import ClearIcon from "@mui/icons-material/Clear";
import AlbumIcon from "@mui/icons-material/Album";
import SaveIcon from "@mui/icons-material/Save";

export interface FileAccessibilityChipProps extends ChipProps {
  accessibility: FileAccessibility;
}

const FileAccessibilityChip: React.FC<FileAccessibilityChipProps> = (props) => {
  const { accessibility, ...otherProps } = props;

  let _icon = <></>;
  let _label = "";
  let _color: ChipProps["color"] = "default";

  switch (accessibility) {
    case FileAccessibility.Disk:
      _icon = <SaveIcon />;
      _label = "Disk";
      _color = "info";
      break;
    case FileAccessibility.Tape:
      _icon = <AlbumIcon />;
      _label = "Tape";
      break;
    case FileAccessibility.DiskAndTape:
      _icon = (
        <>
          <SaveIcon />
          <AlbumIcon />
        </>
      );
      _label = "Disk & Tape";
      _color = "info";
      break;
    case FileAccessibility.Missing:
      _icon = <ClearIcon />;
      _label = "Missing";
      break;
  }

  return <Chip icon={_icon} label={_label} color={_color} {...otherProps} size="small" />;
};

export default FileAccessibilityChip;
